var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPauseCircleOutline = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-270 -950)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(270 950)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,972a10,10,0,1,1,10-10A10.011,10.011,0,0,1,282,972Zm0-18a8,8,0,1,0,8,8A8.009,8.009,0,0,0,282,954Zm3,12h-2v-8h2v8Zm-4,0h-2v-8h2v8Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPauseCircleOutline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause_circle_outline.678862e8.svg";
export { ForwardRef as ReactComponent };